import React from "react";
import { format } from 'date-fns';
import { useSelector } from 'react-redux'
const FooterSection = () => {
  const currentDate = new Date();
  const currentYear = format(currentDate, 'yyyy');
  const companyProfile = useSelector(
    (state) => state.dashboard?.appLayout?.companyProfile
  );

  return (
    <footer className="footer_copy">
      <div className="container">
        <p style={{ textTransform: 'capitalize' }}>Copyright © {currentYear}, {companyProfile?.name}. All rights reserved.
          </p>
      </div>
    </footer>
  );
};

export default FooterSection;
